import React from "react";
import { AlertCircle, Tooltip } from "@opendate-app/setlist";

const iconStyle = {
  display: "inline-flex",
  color: "var(--sl-fg-warning)",
};

export default ({ errors }) => {
  if (!errors || Object.keys(errors).length === 0) {
    return null;
  }

  const message = Object.values(errors).flat().join(", ");

  return (
    <Tooltip title="Errors" supportingText={message} maxWidth={320}>
      <span tabIndex={0} role="img" aria-label={`Errors: ${message}`} style={iconStyle}>
        <AlertCircle width="1em" height="1em" aria-hidden="true" />
      </span>
    </Tooltip>
  );
};
